import { Meeting } from '../stores/reducers/session';
import { getHeaders, getSyncHeaders } from './utils';
import { GraphicInterface } from '../stores/reducers/graphics';
import { MediaItem } from '../stores/reducers/media';
import { GeneratedContent } from '../stores/reducers/generate-content';
import { EntityType } from '../types/enums';
import { appLogger } from '../utils/datadog';

export const requestGenerateContentTemplates = (
	token: string,
) => fetch(
	`${process.env.REACT_APP_API_HOST}/v2/greenroom/generate-content/templates`,
	{
		method: 'GET',
		headers: getHeaders(token) as any,
	},
).then((res) => (res.ok ? res.json() : [])).catch((e) => {
	appLogger.error('error getting content templates, message: ', e?.response?.data?.message, e);
	return [];
});

export const requestGeneratedContent = (
	token: string,
	meeting: Meeting,
) => fetch(
	`${process.env.REACT_APP_API_HOST}/v2/greenroom/generate-content/${meeting.meeting}`,
	{
		method: 'GET',
		headers: getHeaders(token) as any,
	},
).then((res) => (res.ok ? res.json() : [])).catch((e) => {
	appLogger.error('error loading generated content for meeting', {}, e);
	return [];
});

export const requestGeneratedContentById = (
	token: string,
	meeting: Meeting,
	id: number,
) => fetch(
	`${process.env.REACT_APP_API_HOST}/v2/greenroom/generate-content/${meeting.meeting}/${id}`,
	{
		method: 'GET',
		headers: getHeaders(token),
	},
).then((res) => (res.ok ? res.json() : {})).catch((e) => {
	appLogger.error('error loading generated content for meeting', {}, e);
	return {};
});

export const requestDeleteGeneratedContentById = (
	token: string,
	meeting: Meeting,
	id: number,
) => fetch(
	`${process.env.REACT_APP_API_HOST}/v2/greenroom/generate-content/${meeting.meeting}/${id}`,
	{
		method: 'DELETE',
		headers: getHeaders(token),
	},
).then((res) => (res.ok ? id : 0)).catch((e) => {
	appLogger.error('error deleting generated content: ', {}, e);
	return 0;
});

export const upsertContentRequest = (
	token: string,
	roomId: number,
	userId: number,
	associatedContent: GraphicInterface | MediaItem,
	generatedContent: GeneratedContent,
): Promise<boolean> => fetch(
	`${process.env.REACT_APP_SYNC_HOST}/v1/room/${roomId}/content/upsert`,
	{
		method: 'POST',
		headers: getSyncHeaders(token),
		body: JSON.stringify({
			userId,
			generatedContent,
			associatedContent,
		}),
	},
).then((res) => res.ok).catch((e) => {
	appLogger.error('error upserting content: ', {}, e);
	return false;
});

export const publishDraft = (
	token: string,
	room: number,
): Promise<boolean> => fetch(
	`${process.env.REACT_APP_SYNC_HOST}/v1/room/${room}/draft/publish`,
	{
		method: 'PUT',
		headers: getSyncHeaders(token),
	},
).then((res) => !!res?.ok).catch((e) => {
	appLogger.error('error publishing draft: ', {}, e);
	return false;
});

export const discardDraft = (
	token: string,
	room: number,
): Promise<boolean> => fetch(
	`${process.env.REACT_APP_SYNC_HOST}/v1/room/${room}/draft/discard`,
	{
		method: 'DELETE',
		headers: getSyncHeaders(token),
	},
).then((res) => !!res?.ok).catch((e) => {
	appLogger.error('error clearing draft state: ', {}, e);
	return false;
});

export const getDraftEntities = (
	token: string,
	room: number,
	entityType: EntityType,
): Promise<Record<string, any>[]> => fetch(
	`${process.env.REACT_APP_SYNC_HOST}/v1/room/${room}/draft/${entityType}`,
	{
		method: 'GET',
		headers: getSyncHeaders(token),
	},
).then((res) => res.json()).catch((e) => {
	appLogger.error('error getting draft entities: ', {}, e);
	return [];
});
